"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'botTest.tester.name': '测试者名称',
    'botTest.tester.model': 'AI模型',
};
